import { DateTime } from 'luxon';

export const formatDateShortMonth = (dateStr: string): string => {
  const abbreviatedMonths = [
    'January',
    'February',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const dt = DateTime.fromISO(dateStr);
  const monthFull = dt.toFormat('LLLL');
  let month: string;
  if (abbreviatedMonths.includes(monthFull)) {
    if (monthFull === 'September') {
      month = 'Sept.';
    } else {
      month = `${dt.toFormat('LLL')}.`;
    }
  } else {
    month = monthFull;
  }
  return `${month} ${dt.day}, ${dt.year}`;
};
